import {Signal} from "signals"
import queryString from "qs"

class AppController {
  constructor() {
    this.state = {}

    this.sidebar        = {}
    this.sidebar.toggle = new Signal()
    this.sidebar.open   = new Signal()
    this.sidebar.close  = new Signal()

    this.sidebarLeft        = {}
    this.sidebarLeft.toggle = new Signal()
    this.sidebarLeft.open   = new Signal()
    this.sidebarLeft.close  = new Signal()

    this.mobileNav        = {}
    this.mobileNav.toggle = new Signal()
    this.mobileNav.open   = new Signal()
    this.mobileNav.close  = new Signal()

    this.globalPath = []

    this.search        = {}
    this.search.change = new Signal()
    this.state.search  = {
      q: ""
    }

    this.language         = {}
    this.language.changed = new Signal()
  }

  getQueryLanguageParameter(symbol = "&") {
    let lang = this._currentLanguage || "de"
    if ( !lang || lang === "de" ) {
      return ""
    }
    return `${symbol}lang=${lang}`
  }
}

const app = new AppController()

window.app = app //TODO
export default app



// WEBPACK FOOTER //
// ./src/app.controller.js